import React, { useState } from "react";
import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

const faqKeys = ["q1", "q2", "q3", "q4", "q5", "q6", "q7"];
const faqAnswerKeys = ["a1", "a2", "a3", "a4", "a5", "a6", "a7"];

const FAQSection = () => {
  const { t } = useTranslation("common");
  const navigate = useNavigate();
  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <Box
      sx={{
        width: { xs: "100%", md: "80%" },
        maxWidth: "100%",
        mx: "auto",
        backgroundColor: "white",
        borderRadius: "10px",
        border: "1px solid",
        borderColor: "divider",
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
        p: { xs: 2, sm: 3, md: 4 },
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          mb: 2,
        }}
      >
        <HelpOutlineIcon
          sx={{
            fontSize: 40,
            color: "primary.main",
            mr: 1.5,
          }}
        />
        <Typography
          variant="h4"
          fontWeight="bold"
          textAlign="center"
          color="text.primary"
        >
          {t("faq.title")}
        </Typography>
      </Box>
      <Typography
        variant="body1"
        textAlign="center"
        color="text.secondary"
        mb={4}
      >
        {t("faq.subtitle")}
      </Typography>

      <Box sx={{ mb: 3 }}>
        {faqKeys.map((qKey, index) => (
          <Accordion
            key={qKey}
            expanded={expanded === `panel${index}`}
            onChange={handleChange(`panel${index}`)}
            sx={{
              mb: 2,
              borderRadius: "8px",
              border: "1px solid #e0e0e0",
              boxShadow: "none",
              "&:before": {
                display: "none",
              },
              "&.Mui-expanded": {
                margin: "0 0 16px 0",
                boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
              },
            }}
          >
            <AccordionSummary
              expandIcon={
                <ExpandMoreIcon
                  sx={{
                    color: "primary.main",
                  }}
                />
              }
              sx={{
                "&.Mui-expanded": {
                  borderBottom: "1px solid #e0e0e0",
                },
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 600,
                  color: "text.primary",
                  fontSize: "1rem",
                }}
              >
                {t(`faq.${qKey}`)}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography
                variant="body2"
                sx={{
                  color: "text.secondary",
                  lineHeight: 1.6,
                }}
              >
                {t(`faq.${faqAnswerKeys[index]}`)}
              </Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>

      <Box sx={{ textAlign: "center", mt: 3 }}>
        <Button
          variant="outlined"
          color="primary"
          onClick={() => navigate("/faq")}
          sx={{
            textTransform: "none",
            fontWeight: "bold",
            px: 4,
            py: 1.5,
            borderRadius: "8px",
            borderColor: "primary.main",
            color: "primary.main",
            "&:hover": {
              borderColor: "primary.main",
              backgroundColor: "rgba(30, 58, 138, 0.08)",
            },
          }}
        >
          {t("faq.viewAllQuestions")}
        </Button>
      </Box>
    </Box>
  );
};

export default FAQSection;

